import { Box } from "@mui/material";
import React, { useState } from "react";

interface FormWrapperProps {
  onSubmit: () => void | Promise<void>;
  children: React.ReactNode | ((error: string | null) => React.ReactNode);
}

export default function FormWrapper({ onSubmit, children }: FormWrapperProps) {
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError(null);
    try {
      await onSubmit();
    } catch (err: any) {
      setError(err?.message || "An unexpected error occurred.");
    }
  };

  return (
    <Box sx={{ maxWidth: 600, mx: "auto", px: "1rem", py: "1rem" }}>
      <Box
        component="form"
        onKeyDown={(e: React.KeyboardEvent) => {
          if (e.key === "Enter" && !e.defaultPrevented) {
            const target = e.target as HTMLElement;
            const tagName = target.tagName.toLowerCase();
            if (tagName !== "textarea") {
              e.preventDefault();
              (e.currentTarget as HTMLFormElement).requestSubmit();
            }
          }
        }}
        onSubmit={handleSubmit}
      >
        {typeof children === "function" ? children(error) : children}
      </Box>
    </Box>
  );
}
